var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['c-favoris', {menu: _vm.$store.state.ui.show_favoris_menus}],attrs:{"id":"all_favoris"}},[_c('Filter_allfavoris'),(_vm.$store.state.ui.allfavoris_subcontent)?_c('Subcontent_'+_vm.$store.state.ui.allfavoris_subcontent,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }